import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
export const Capslock = props => {
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("path", { d: "M19,18 L19,20 L5,20 L5,18 L19,18 Z M12,2.09765663 L18.8692104,9.02023108 L15,9.02023108 L15,15.9871754 L9,15.9871754 L9,9.02023108 L5.08053147,9.02023108 L12,2.09765663 Z" })));
};
export default Capslock;
